export default __webpack_public_path__ + "static/media/Winch.52085c6b.MOV";